"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _default = exports.default = function _default(brandingId) {
  switch (brandingId) {
    case 12:
      return 'concur_default';
    default:
      return 'sap_horizon';
  }
};